import { useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";


type Lang = "pl" | "en" | "zh";

type Model = {
  key: string;
  to?: string;
  pl: { title: string; claim: string; body: string; best: string };
  en: { title: string; claim: string; body: string; best: string };
  zh: { title: string; claim: string; body: string; best: string };
};

/** Modele współpracy - pełny zakres usług rekrutacyjnych IT. */
export const SERVICE_MODELS: Model[] = [
  {
    key: "contingency",
    pl: {
      title: "Rekrutacja z prowizją od zatrudnienia",
      claim: "Szybka reakcja na pilną potrzebę",
      body: "Płacisz dopiero za zatrudnienie. Poszukiwania uruchamiamy w ciągu 48 godzin i przekazujemy krótką listę kandydatów zweryfikowanych technicznie.",
      best: "Pojedyncze, pilne wakaty",
    },
    en: {
      title: "Contingency recruitment",
      claim: "Fast response to an urgent need",
      body: "You pay only on hire. We start sourcing within 48 h and deliver a shortlist of technically vetted candidates.",
      best: "One-off, urgent vacancies",
    },
    zh: {
      title: "成功付费招聘",
      claim: "快速响应紧急需求",
      body: "录用后付费。48 小时内启动寻访，交付经过技术验证的候选人短名单。",
      best: "单个紧急岗位",
    },
  },
  {
    key: "rpo",
    to: "/services/it-rpo-poland",
    pl: {
      title: "RPO",
      claim: "Twój zewnętrzny dział rekrutacji IT",
      body: "Przejmujemy cały proces: dedykowani rekruterzy, koordynacja, narzędzia i raportowanie. Twój zespół wraca do rozwoju produktu.",
      best: "Firmy skalujące zespoły",
    },
    en: {
      title: "RPO",
      claim: "Your external IT recruitment department",
      body: "We run the full process: dedicated recruiters, coordination, tooling and reporting. Your team goes back to building product.",
      best: "Companies scaling teams",
    },
    zh: {
      title: "RPO 招聘流程外包",
      claim: "您的外部 IT 招聘部门",
      body: "我们承接完整流程：专属招聘顾问、协调、工具与报告，让您的团队专注产品。",
      best: "快速扩张的团队",
    },
  },
  {
    key: "master-vendor",
    pl: {
      title: "Master Vendor",
      claim: "Centralne zarządzanie rekrutacją IT",
      body: "Jeden punkt kontaktu dla wszystkich procesów IT. Koordynujemy dostawców, pilnujemy standardu i spójnego raportowania.",
      best: "Organizacje ze stałym wolumenem",
    },
    en: {
      title: "Master Vendor",
      claim: "Centralised IT hiring management",
      body: "One point of contact for every IT process. We coordinate vendors, hold the quality bar and unify reporting.",
      best: "Organisations with steady volume",
    },
    zh: {
      title: "主供应商模式",
      claim: "集中管理 IT 招聘",
      body: "所有 IT 招聘流程的单一联络点。我们协调供应商、统一标准与报告。",
      best: "有持续招聘量的组织",
    },
  },
  {
    key: "on-demand",
    pl: {
      title: "Recruiter on demand",
      claim: "Elastyczne wsparcie krótkoterminowe",
      body: "Rekruter IT pracuje w Twoim zespole przez kilka tygodni lub miesięcy, rozliczany za czas pracy, bez zatrudniania go na etat.",
      best: "Szczyty rekrutacyjne i zastępstwa",
    },
    en: {
      title: "Recruiter on demand",
      claim: "Flexible short-term support",
      body: "An IT recruiter embedded in your team for weeks or months, billed for time, with no headcount to hire.",
      best: "Hiring peaks and cover",
    },
    zh: {
      title: "按需招聘顾问",
      claim: "灵活的短期支持",
      body: "IT 招聘顾问嵌入您的团队数周或数月，按工时计费，无需增加编制。",
      best: "招聘高峰与人员替补",
    },
  },
  {
    key: "executive",
    pl: {
      title: "Executive search",
      claim: "Liderzy technologiczni",
      body: "Poufne poszukiwania na stanowiska CTO, dyrektora inżynierii i szefa obszaru danych, wraz z oceną kompetencji przywódczych i dopasowania do kultury organizacji.",
      best: "Role kierownicze i C-level",
    },
    en: {
      title: "Executive search",
      claim: "Technology leaders",
      body: "Confidential searches for CTO, VP Engineering and Head of Data roles, with leadership and culture-fit assessment.",
      best: "Leadership and C-level roles",
    },
    zh: {
      title: "高管猎聘",
      claim: "技术领导者",
      body: "面向 CTO、工程副总裁、数据负责人的保密搜寻，含领导力与文化契合评估。",
      best: "管理层与 C 级岗位",
    },
  },
  {
    key: "volume",
    pl: {
      title: "Rekrutacja wolumenowa",
      claim: "Skalowalny proces dla zespołów",
      body: "Budujemy całe zespoły lub nową lokalizację. Równoległe ścieżki selekcji, wspólne kryteria, jeden raport statusu.",
      best: "Nowe zespoły i lokalizacje",
    },
    en: {
      title: "Volume recruitment",
      claim: "Scalable process for whole teams",
      body: "Building entire teams or a new site. Parallel selection tracks, shared criteria, one status report.",
      best: "New teams and locations",
    },
    zh: {
      title: "批量招聘",
      claim: "面向整支团队的可扩展流程",
      body: "组建完整团队或新站点。并行筛选、统一标准、单一状态报告。",
      best: "新团队与新地点",
    },
  },
  {
    key: "contracting",
    pl: {
      title: "IT contracting",
      claim: "Specjaliści B2B na czas projektu",
      body: "Kontraktorzy na B2B z rozliczeniem miesięcznym, dostępni od zaraz, bez długoterminowego zobowiązania etatowego.",
      best: "Projekty o określonym czasie",
    },
    en: {
      title: "IT contracting",
      claim: "Contract specialists for project time",
      body: "B2B contractors billed monthly, available at short notice, with no long-term headcount commitment.",
      best: "Time-boxed projects",
    },
    zh: {
      title: "IT 外包合同制",
      claim: "项目周期内的合同制专家",
      body: "按月结算的 B2B 合同顾问，可快速到岗，无需长期编制承诺。",
      best: "有明确周期的项目",
    },
  },
  {
    key: "advisory",
    pl: {
      title: "Talent advisory",
      claim: "Doradztwo poza samą rekrutacją",
      body: "Dane o wynagrodzeniach, porównanie procesu z rynkiem, budowanie marki pracodawcy i przegląd ścieżki rekrutacyjnej, zanim wydasz budżet na kolejny etat.",
      best: "Strategia zatrudnienia",
    },
    en: {
      title: "Talent advisory",
      claim: "Support beyond recruitment itself",
      body: "Salary data, process benchmarks, employer branding and funnel audits - before you spend budget on the next hire.",
      best: "Hiring strategy",
    },
    zh: {
      title: "人才咨询",
      claim: "超越招聘本身的支持",
      body: "薪酬数据、流程基准、雇主品牌与漏斗审计——在投入下一笔招聘预算之前。",
      best: "招聘策略",
    },
  },
];

const LABELS = {
  pl: {
    best: "Najlepsze dla",
    more: "Zobacz usługę",
    featured: "Najczęściej wybierane",
    expand: "Rozwiń",
    collapse: "Zwiń",
    status: ["System aktywny", "Zasięg: PL / CEE", "Aktualizacja: 2026.Q3"],
  },
  en: {
    best: "Ideal for",
    more: "View service",
    featured: "Most chosen",
    expand: "Expand",
    collapse: "Collapse",
    status: ["System active", "Coverage: PL / CEE", "Update: 2026.Q3"],
  },
  zh: {
    best: "适合",
    more: "查看服务",
    featured: "最常选择",
    expand: "展开",
    collapse: "收起",
    status: ["系统运行中", "覆盖：PL / CEE", "更新：2026.Q3"],
  },
} as const;

const CTA = {
  pl: {
    tag: "DOBÓR",
    title: "Nie wiesz, który model?",
    body: "Opisz swoją potrzebę, a zaproponujemy model współpracy i harmonogram w ciągu doby.",
    action: "Porozmawiajmy",
  },
  en: {
    tag: "MATCH",
    title: "Not sure which model?",
    body: "Describe the need - we propose a model and timeline within 24 h.",
    action: "Talk to us",
  },
  zh: {
    tag: "匹配",
    title: "不确定选哪种模式？",
    body: "描述您的需求——我们将在 24 小时内给出模式与时间表。",
    action: "联系我们",
  },
} as const;

const TAGS: Record<string, string> = {
  contingency: "STANDARD",
  rpo: "INTEGRATED",
  "master-vendor": "CENTRAL",
  "on-demand": "FLEX",
  executive: "PREMIUM",
  volume: "SCALE",
  contracting: "B2B",
  advisory: "STRATEGY",
};

/** Rogowe znaczniki - detal cyber-brutalistyczny. */
function Corners() {
  return (
    <>
      <span
        aria-hidden
        className="pointer-events-none absolute left-0 top-0 h-3 w-3 border-l border-t border-lime-300/0 transition-colors duration-300 group-hover:border-lime-300/70"
      />
      <span
        aria-hidden
        className="pointer-events-none absolute bottom-0 right-0 h-3 w-3 border-b border-r border-lime-300/0 transition-colors duration-300 group-hover:border-lime-300/70"
      />
    </>
  );
}

function FeaturedCard({ model, index, lang }: { model: Model; index: number; lang: Lang }) {
  const copy = model[lang];
  const labels = LABELS[lang];

  const inner = (
    <article className="group relative flex h-full flex-col justify-between overflow-hidden bg-lime-300/[0.05] p-7 transition-colors duration-500 hover:bg-lime-300/[0.09] md:p-10">
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.5] mix-blend-overlay"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to bottom, rgba(190,242,100,0.06) 0px, rgba(190,242,100,0.06) 1px, transparent 1px, transparent 4px)",
        }}
      />
      <span className="pointer-events-none absolute right-4 top-4 font-mono text-[10px] tracking-[0.22em] text-lime-300/40">
        [ {TAGS[model.key]} ]
      </span>
      <Corners />

      <div className="relative z-10">
        <div className="mb-6 flex h-11 w-11 items-center justify-center border border-lime-300 transition-colors duration-500 group-hover:bg-lime-300">
          <span className="h-1.5 w-1.5 bg-lime-300 transition-colors duration-500 group-hover:bg-black" />
        </div>
        <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-lime-300/80">
          {labels.featured}
        </span>
        <h3 className="mt-3 text-3xl font-bold uppercase tracking-tight text-white md:text-4xl">
          {copy.title}
        </h3>
        <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-white/70">
          {copy.claim}
        </p>
        <p className="mt-5 max-w-[46ch] text-base leading-relaxed text-white/60">{copy.body}</p>
      </div>

      <div className="relative z-10 mt-10 flex items-end justify-between gap-4">
        <div>
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/45">
            {labels.best}: <span className="text-lime-300/80">{copy.best}</span>
          </span>
          {model.to && (
            <span className="mt-3 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.24em] text-lime-300 transition-transform duration-300 group-hover:translate-x-1">
              {labels.more} <span aria-hidden>_</span>
            </span>
          )}
        </div>
        <span
          aria-hidden
          className="font-mono text-5xl font-black leading-none text-white/[0.06] md:text-6xl"
        >
          {String(index).padStart(2, "0")}
        </span>
      </div>

      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 translate-x-1 translate-y-1 border border-lime-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
      />
    </article>
  );

  return model.to ? (
    <Link to={model.to} className="block h-full">
      {inner}
    </Link>
  ) : (
    inner
  );
}

function ModelCard({
  model,
  index,
  lang,
  wide = false,
}: {
  model: Model;
  index: number;
  lang: Lang;
  wide?: boolean;
}) {
  const copy = model[lang];
  const labels = LABELS[lang];
  const [open, setOpen] = useState(false);

  return (
    <article
      className={`group relative flex h-full flex-col bg-[#080b09] p-6 text-left transition-colors duration-300 hover:bg-white/[0.035] ${
        open ? "bg-white/[0.035]" : ""
      }`}
    >
      <Corners />
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="relative z-10 flex w-full flex-1 flex-col text-left"
      >
        <span className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.24em] text-white/30">
          <span>
            {String(index).padStart(2, "0")} <span className="text-white/15">//</span>{" "}
            {TAGS[model.key]}
          </span>
          <span
            aria-hidden
            className={`text-lime-300/70 transition-transform duration-300 ${
              open ? "rotate-45" : ""
            }`}
          >
            +
          </span>
        </span>

        <h4
          className={`mt-7 font-bold uppercase tracking-tight text-white transition-colors group-hover:text-lime-300 ${
            wide ? "text-2xl" : "text-xl"
          }`}
        >
          {copy.title}
        </h4>
        <p className="mt-2 text-sm text-white/50">{copy.claim}</p>

        <div
          className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out ${
            open ? "mt-4 grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden">
            <p className="max-w-[46ch] text-sm leading-relaxed text-white/60">{copy.body}</p>
            <span className="mt-4 block font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
              {labels.best}: <span className="text-lime-300/80">{copy.best}</span>
            </span>
          </div>
        </div>

        <span className="mt-auto pt-6 font-mono text-[9px] uppercase tracking-[0.24em] text-white/25 transition-colors group-hover:text-lime-300/70">
          {open ? labels.collapse : labels.expand}
        </span>
      </button>

      {model.to && (
        <Link
          to={model.to}
          className="relative z-10 mt-4 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-lime-300"
        >
          {labels.more} <span aria-hidden>→</span>
        </Link>
      )}

      <span
        aria-hidden
        className={`pointer-events-none absolute bottom-0 left-0 h-[2px] bg-lime-300 transition-all duration-500 ${
          open ? "w-full" : "w-0 group-hover:w-full"
        }`}
      />
    </article>
  );
}

export function ServiceModels({ lang }: { lang: Lang }) {
  const featured = SERVICE_MODELS.find((m) => m.key === "rpo")!;
  const featuredIndex = SERVICE_MODELS.indexOf(featured) + 1;
  const rest = SERVICE_MODELS.filter((m) => m.key !== "rpo");
  const labels = LABELS[lang];

  return (
    <div>
      <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2 xl:grid-cols-4">
        <Reveal as="div" className="bg-[#050706] md:col-span-2 xl:row-span-2">
          <FeaturedCard model={featured} index={featuredIndex} lang={lang} />
        </Reveal>

        {rest.map((model, i) => (
          <Reveal
            as="div"
            key={model.key}
            delayMs={60 + i * 45}
            className="bg-[#050706]"
          >
            <ModelCard
              model={model}
              index={SERVICE_MODELS.indexOf(model) + 1}
              lang={lang}
            />
          </Reveal>
        ))}

        <Reveal as="div" delayMs={400} className="bg-[#050706]">
          <a
            href="#contact"
            className="group relative flex h-full flex-col justify-between bg-lime-300/[0.04] p-6 transition-colors duration-300 hover:bg-lime-300/[0.09]"
          >
            <Corners />
            <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-lime-300/70">
              09 <span className="text-white/15">//</span> {CTA[lang].tag}
            </span>
            <span className="mt-7 block text-xl font-bold uppercase tracking-tight text-white">
              {CTA[lang].title}
            </span>
            <span className="mt-2 block text-sm text-white/50">{CTA[lang].body}</span>
            <span className="mt-auto pt-6 font-mono text-[10px] uppercase tracking-[0.24em] text-lime-300 transition-transform duration-300 group-hover:translate-x-1">
              {CTA[lang].action} <span aria-hidden>→</span>
            </span>
          </a>
        </Reveal>
      </div>


      <div className="mt-4 flex flex-wrap items-center gap-4 font-mono text-[10px] uppercase tracking-[0.22em] text-white/25">
        <span className="flex items-center gap-2">
          <span className="h-1 w-1 animate-pulse bg-lime-300" />
          {labels.status[0]}
        </span>
        <span className="h-3 w-px bg-white/10" />
        <span>{labels.status[1]}</span>
        <span className="h-3 w-px bg-white/10" />
        <span>{labels.status[2]}</span>
      </div>
    </div>
  );
}
